import { StripeConfig } from './config';
import { StripeElementsService } from './stripe-elements.service';
import { StripeFactoryService } from './stripe-factory.service';
import { StripeService } from './stripe.service';

export function provideStripe(publishableKey: string) {
  return [
    StripeFactoryService,
    StripeService,
    StripeElementsService,
    {
      provide: StripeConfig,
      useValue: new StripeConfig(publishableKey),
    },
  ];
}
